import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
} from '@angular/core';
import { UiSegmentedOption } from '../../types/ui-segmented-option.interface';

@Component({
  selector: 'ui-segmented',
  imports: [],
  templateUrl: './ui-segmented.component.html',
  styleUrl: './ui-segmented.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSegmentedComponent {
  public readonly options: InputSignal<readonly UiSegmentedOption[]> =
    input.required<readonly UiSegmentedOption[]>();
  public readonly activeOptionId: InputSignal<string> = input.required<string>();
  public readonly ariaLabel: InputSignal<string> = input.required<string>();
  public readonly activeOptionIdChange: OutputEmitterRef<string> = output<string>();

  protected handleOptionSelected(option: UiSegmentedOption): void {
    if (option.disabled === true) {
      return;
    }

    this.activeOptionIdChange.emit(option.id);
  }
}
